import { set16ToRgba } from '@/utils/colorUtils';
import { useCallback, useEffect, useState } from 'react';
import ProductImage from './ProductImage';

interface ProductImageWrapperProps {
  /**
   * 产品信息
   */
  product?: {
    image_gray?: string;
    img?: string;
    image?: string;
    background_image_of_mirror_leg?: string;
    frame_background_image?: string;
  };
  /**
   * 镜片信息
   */
  lens?: {
    is_transparency_change?: number;
    color_no?: string;
    transparency?: number;
    polarized_light_transparency?: number;
    polarized_light_color_no?: string;
  };
  /**
   * 图片URL
   */
  imageUrl?: string;
  /**
   * 是否为镜片
   */
  isGlass?: boolean;

  /**
   * 是否为灰色图片
   */
  onlyShowImage?: boolean;
  /**
   * 盒子样式
   */
  boxClassName?: string;
}

export default function ProductImageWrapper({
  product = {},
  lens = {},
  imageUrl = '',
  isGlass = true,
  onlyShowImage = false,
  boxClassName = '',
}: ProductImageWrapperProps) {
  const [showFrameBg, setShowFrameBg] = useState(false);
  const [legBg, setLegBg] = useState('');
  const [frameBg, setFrameBg] = useState('');
  const [frameBgColor, setFrameBgColor] = useState('');
  const [originGlassImg, setOriginGlassImg] = useState('');
  const [isGradient, setIsGradient] = useState(false);
  const [isGrayImage, setIsGrayImage] = useState(false);

  // Calculate frame background color
  const frameBgColorFunc = useCallback(() => {
    let bgTransparent = 'transparent';
    const frameData = lens || {};
    const { color_no } = frameData;
    const { transparency } = frameData;
    const { polarized_light_transparency } = frameData;
    const { polarized_light_color_no } = frameData;
    const color2 = polarized_light_color_no || ''; // 渐变色
    const transparency2 = polarized_light_transparency || 0; // 渐变色透明度

    if (color_no && transparency) {
      if (color2 !== '' && +transparency2 !== 0) {
        bgTransparent = `linear-gradient(${set16ToRgba(color_no, transparency)}, ${set16ToRgba(
          color2,
          transparency2,
        )})`;
      } else {
        bgTransparent = set16ToRgba(color_no, transparency);
      }
    }

    return bgTransparent;
  }, [lens]);

  // Initialize component data
  const init = useCallback(() => {
    if (onlyShowImage) {
      setOriginGlassImg(imageUrl); // 原图
    } else {
      setOriginGlassImg(product?.image_gray || product?.img || product?.image || imageUrl); // 原图
    }
    setLegBg(product?.background_image_of_mirror_leg || ''); // 镜腿
    setFrameBg(product?.frame_background_image || ''); // 镜框
    setIsGradient(lens?.is_transparency_change === 1); // 渐变
    setFrameBgColor(frameBgColorFunc());
    setShowFrameBg(!!product?.background_image_of_mirror_leg && !!product?.frame_background_image);
    // 判断是否存在灰色图片
    // setIsGrayImage(!!product?.image_gray);
  }, [product, lens, imageUrl, frameBgColorFunc]);

  // Run init on mount and when dependencies change
  useEffect(() => {
    init();
  }, [init]);

  useEffect(() => {
    // console.log('isGrayImage', isGrayImage);
    if (showFrameBg) {
      setIsGrayImage(false);
      return;
    }
    setIsGrayImage(
      // @ts-ignore
      (product?.image?.product_gray && product.image.product_gray.length > 0) ||
        !!product?.image_gray,
    );
  }, [showFrameBg]);

  return (
    <ProductImage
      showFrameBg={showFrameBg}
      legBg={legBg}
      frameBg={frameBg}
      frameBgColor={frameBgColor}
      originGlassImg={originGlassImg}
      isGradient={isGradient}
      isGlass={isGlass}
      isGrayImage={isGrayImage}
      boxClassName={boxClassName}
    />
  );
}
